import { z } from '@harvestiq/zod';
import { legacySequelizeUserSchema } from './shared';

export const updateUserRequestSchema = z.object({
  firstName: z.string().trim().optional(),
  lastName: z.string().trim().optional(),
  email: z.string().trim().toLowerCase().email().optional(),
});
export type UpdateUserRequest = z.infer<typeof updateUserRequestSchema>;

export const updateUserResponseSchema = z.object({
  user: legacySequelizeUserSchema,
});
export type UpdateUserResponse = z.infer<typeof updateUserResponseSchema>;
